import { render } from "./LicenseExpiredView.vue?vue&type=template&id=952d6b6c&scoped=true"
import script from "./LicenseExpiredView.vue?vue&type=script&lang=js"
export * from "./LicenseExpiredView.vue?vue&type=script&lang=js"

import "./LicenseExpiredView.vue?vue&type=style&index=0&id=952d6b6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-952d6b6c"]])

export default __exports__